<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb page-title="Validación Legal" directory="Aprobación de Informe Jurídico para la Acreditación" :icon="'trello'" />
            </div>

            <div class="col-sm-12 col-md-6">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-primary btn-with-shadow" @click="() => { $hub.$emit('reload-table');}
            ">
                        <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
                    </button>
                </div>
            </div>

            <div class="col-md-12">
                <app-tab :tabs="tabsHorizontal" type="horizontal" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                app_type: "",
                icon: "settings",
                tabsHorizontal: [{
                    icon: "check-circle",
                    name: "Aprobación de Informe Jurídico para la Acreditación",
                    component: "legal-validation-613-table",
                    permission: "",
                }, ],
            };
        },
        created() {},
        methods: {},
    };
</script>